module.exports = __webpack_public_path__ + "img/Character_Hu-Tao_Thumb.2d49b773.png";